import React from 'react';
import { useParams } from 'react-router-dom';
import { useQueries } from '@tanstack/react-query';
// import { Progress, ProgressSize, ProgressMeasureLocation } from '@patternfly/react-core';

import ContentPage from 'components/ContentView/ContentPage/ContentPage';
import useAlerts from 'utils/hooks/useAlerts';
import createQueryRequest from 'services/createQueryRequest';
import useAPI from 'services/useAPI';
import { ResourceType } from 'utils/types';
import { org2models } from './queries';
import RelationTable from 'components/RelationTable/RelationTable';
import useRelations from 'utils/hooks/useRelations';
import { useRelationData, createRelationQueryData, createOrgOwnerRelationQueryData } from './queries';
import { modelKeys } from 'components/Admin/Model/queries';


const OrgToModelsRelations = ({ breadcrumbs }) => {
  const api = useAPI();
  const { orgId } = useParams();
  const [alerts,, addErrorAlert] = useAlerts();

  const [modelsQuery, modelsRelationQuery, modelsOwnerQuery] = useQueries({
    queries: [
      { queryKey: modelKeys.models(), queryFn: createQueryRequest(api.core.getModels) },
      { queryKey: org2models.org(createRelationQueryData(ResourceType.Model, orgId)), queryFn: createQueryRequest(api.core.findRelationships) },
      { queryKey: org2models.org(createOrgOwnerRelationQueryData(ResourceType.Model)), queryFn: createQueryRequest(api.core.findRelationships) }
    ]
  });

  const models = useRelationData({
    isLoading: modelsQuery.isLoading || modelsRelationQuery.isLoading || modelsOwnerQuery.isLoading,
    resources: modelsQuery.data,
    resourceRelations: modelsRelationQuery.data,
    ownedRelations: modelsOwnerQuery.data,
    resourceType: ResourceType.Model
  });

  const { updateRelations, deleteRelations } = useRelations({
    refetchFn: modelsRelationQuery.refetch,
    queryKey: org2models.org(createRelationQueryData(ResourceType.Model)),
    onError: addErrorAlert
  });

  return (
    <ContentPage
      breadcrumb={breadcrumbs}
    >
      { alerts }
      { /* <Progress
        min={0}
        max={100}
        value={modelsQuery.isLoading || modelsRelationQuery.isLoading || modelsOwnerQuery.isLoading ? 33 : 100}
        size={ProgressSize.sm}
        measureLocation={ProgressMeasureLocation.outside}
      /> */ }
      <RelationTable
        orgId={orgId}
        resources={models}
        isLoading={modelsQuery.isLoading || modelsRelationQuery.isLoading || modelsOwnerQuery.isLoading}
        updateRelationsFn={updateRelations.mutate}
        deleteRelationsFn={deleteRelations.mutate}
      />
    </ContentPage>
  );
};

export default OrgToModelsRelations;
